import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-warning',
  templateUrl: './modal-warning.component.html',
  styleUrls: ['./modal-warning.component.scss']
})
export class ModalWarningComponent implements OnInit {
  @Output() onSave: EventEmitter<any> = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<ModalWarningComponent>) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }

  save() {
    this.onSave.emit(true);
    this.closeDialog();
  }

  notSave() {
    this.onSave.emit(false);
    this.closeDialog();
  }
}
